export abstract class BaseEntity {
  static from<T extends BaseEntity>(this: new () => T, raw: Partial<T>): T {
    return Object.assign(new this(), raw);
  }
}
